import { Button, Text } from "@mantine/core";
import React, { useState } from "react";
import styles from "./Section2.module.scss";
import { useNavigate } from "react-router-dom";
import obligationsicon from "./obligationsmanager.png";
import recoveriesicon from "./recoveriesicon.png";
import agreementsicon from "./agreementsmanager.png";
import constants from "../../../utilities/constants";

const activeModules = [
  {
    id: 1,
    disabled: false,
    name: "Contracts Studio",
    icon: "https://cdn1.iconfinder.com/data/icons/digital-banking-vol-1/80/contract__partnership__agreement__handshake_-512.png",
    url: "/app/agreements_manager/",
  },
  {
    id: 2,
    disabled: false,
    name: "Obligations Hub",
    icon: "https://img.icons8.com/ios/512/todo-list.png",
    // url: "https://obdemoapp.truecounsel.in/login"
    // url: "https://obligationapp.truecounsel.in/login"
    // url: "http://localhost:3001/login",
    url: constants.obligationsUrl,
  },
  {
    id: 3,
    disabled: true,
    name: "Receivables Engine",
    icon: "https://cdn-icons-png.flaticon.com/512/3535/3535035.png",
    // url: "https://recoveryappdemo.truecounsel.in/app/login",
    // url: "https://wappsysrecoveries.truecounsel.in/app/login",
    url: constants.recoveryUrl,

    // url: "https://wappsyssandboxrecoveries.truecounsel.in/app/login",
  },
];

function Section2() {
  const [state, setState] = useState(false);
  const navigate = useNavigate();

  //  const handleAgreementsManagerClick = () => {
  //   // console.log('press');
  //   window.open("/app/agreements_manager/", "_blank");
  //  };

  // //  const handleAgreementsManagerClick2 = () => {
  // //   console.log('press');
  // //    navigate("/app/agreements_manager/notifications");
  // //  };
  //  const handleNotificationsClick = () => {
  //    navigate("/app/agreements_manager/notifications");
  //  };

  const handleClick = (url) => {
    window.open(`${url}`, "_blank");
  };
  return (
    <div>
      <div>
        <div className="mb-12 secondary-heading text-center font-bold text-4xl">
          Contracts Simplified | Growth Amplified | Trust Fortified
        </div>
        <div
          className={`mt-3 grid grid-cols-${activeModules.length} gap-2 mb-5 justify-center items-center `}
        >
          {activeModules.map((module) => (
            <div
              style={{
                // border: "2px solid red",
                position: "relative",
              }}
              className="mx-auto"
              key={module.id}
            >
              {/* <button
                disabled={module.disabled}
                onClick={() => handleClick(module.url)}
              >
                <div>
                  <div style={{ paddingLeft: "30%", paddingRight: "30%" }}>
                    <img className={`${styles.img}`} src={module.icon} />
                  </div>
                  <Text
                    className="text-center mt-2 text-2xl font-bold "
                    // style={{
                    //   color: "#1b6f8d",
                    // }}
                  >
                    {module.name}
                  </Text>
                </div>
              </button> */}
              <button
                disabled={module.disabled}
                onClick={() => handleClick(module.url)}
                className="w-full" // Ensure button takes full width of grid cell
              >
                <div style={{ paddingLeft: "25%", paddingRight: "25%" }}>
                  {/* The wrapper holds the background gradient */}
                  <div className={styles.iconWrapper}>
                    <img
                      className={styles.iconImage}
                      src={module.icon}
                      alt={module.name}
                    />
                  </div>
                </div>

                <Text className="text-center mt-4 text-2xl">
                  {module.name}
                </Text>
              </button>
            </div>
          ))}

          {/* <Button
            className={`${styles.buttonCommon}`}
            variant="outline"
            onClick={handleDocumentsManagerClick}
            
            style={
              !state
                ? { background: "#1b6f8d", color: "white" }
                : { background: "white", color: "#1b6f8d" }
            }
            >
              documents manager
            </Button> */}
          {/* <Button
            className={`${styles.buttonCommon} `}
            variant="outline"
            style={{
              background: "white",
              color: "#1b6f8d",
              border: "2px solid #1b6f8d",
              
            }}
            disabled
          >
            <div style={{width: "auto", display: "flex", flexDirection: "column" }}>
              <div style={{ display: "block", textAlign: "center" }}>
                disputes manager
              </div>
              <div
                style={{
                  display: "block",
                  fontSize: "15px",
                  textAlign: "center",
                  fontFamily: "sans-serif"
                }}
              >
                coming soon
              </div>
            </div>
          </Button> */}
        </div>
      </div>
    </div>
  );
}
export default Section2;
